const PAYMENT_METHODS = {
  check: 'Check',
  echeck: 'eCheck',
  compensation: 'Compensation',
  one_inc: 'One Inc',
  uk_bank_transfer: 'UK Bank Transfer',
  iban_bank_transfer: 'IBAN Bank Transfer',
  commerce_bank: 'Commerce Bank',
  au_bank_transfer: 'AU Bank Transfer',
  nz_bank_transfer: 'NZ Bank Transfer',
  us_ach: 'US ACH',
} as const;

export default PAYMENT_METHODS;
